import { apiCaller } from '@/api/apiCaller';
import { apihost } from '@/api/urls';

const getAll = () => apiCaller.get('/country/', apihost);

export const countryApi = {
    getAll,
};
